module.exports = __webpack_public_path__ + "img/dangdang.05b0fb4c.png";